// src/components/icons/FileTypeIcon.jsx
import React from 'react';
import pdfFileSvg from '../assets/pdf_file.svg';
import csvFileSvg from '../assets/csv_file.svg';
import wordDocFileSvg from '../assets/word_doc_file.svg';
import blenderFileSvg from '../assets/blender_file.svg';
import freecadFileSvg from '../assets/freecad_file.svg';
import jupyterNotebookSvg from '../assets/jupyter_notebook.svg';
import kicadFileSvg from '../assets/kicad_file.svg';

/**
 * File type icon component - displays appropriate icon based on file type
 * Uses themed colors that adapt to light/dark mode while maintaining file type recognition
 */
function FileTypeIcon({ type, style = {} }) {
  const lowerType = (type || '').toLowerCase();

  let src;
  if (lowerType.includes('pdf')) {
    src = pdfFileSvg;
  } else if (lowerType.includes('csv')) {
    src = csvFileSvg;
  } else if (
    lowerType.includes('doc') ||
    lowerType.includes('msword') ||
    lowerType.includes('wordprocessingml')
  ) {
    src = wordDocFileSvg;
  } else if (
    lowerType.includes('blender')
  ) {
    src = blenderFileSvg;
  } else if (
    lowerType.includes('freecad')
  ) {
    src = freecadFileSvg;
  } else if (
    lowerType.includes('jupyterlab')
  ) {
    src = jupyterNotebookSvg;
  } else if (
    lowerType.includes('kicad')
  ) {
    src = kicadFileSvg;
  }

  const handleImageError = (e) => {
    console.error('Failed to load SVG icon for type:', type, 'src:', src);
    // Fallback to a simple text icon
    e.target.style.display = 'none';
    const parent = e.target.parentElement;
    if (parent) {
      const fallback = document.createElement('div');
      fallback.textContent = type ? type.charAt(0).toUpperCase() : '?';
      fallback.style.cssText = `
        width: 24px;
        height: 24px;
        margin-right: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #6b7280;
        color: white;
        border-radius: 4px;
        font-size: 12px;
        font-weight: bold;
      `;
      parent.appendChild(fallback);
    }
  };

  return (
    <img
      src={src}
      alt={`${type} file`}
      style={{
        width: '24px',
        height: '24px',
        marginRight: '6px',
        ...style,
      }}
      onError={handleImageError}
    />
  );
}

export default FileTypeIcon;
